// Nav.js

import React from 'react';
import './Nav.css';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo/full_logo.svg';
import { AiOutlineAndroid } from "react-icons/ai";
import { FaAppStoreIos } from "react-icons/fa6";
import { IoIosLogIn } from "react-icons/io";
import { AiOutlineApple } from "react-icons/ai";

const Nav = () => {
  return (
    <nav>
      <div className="n-logo">
        <Link to="/" className='logo' style={{ color: "black", textDecoration: "none" }}>
          <img src={logo} width="150" height="50" alt="logo" />
        </Link>
      </div>

      <div className="social-icons">
      <Link to="https://play.google.com/store/apps/details?id=com.memyfolks" target="_blank" >
        <AiOutlineAndroid className='nav-icons' />
        </Link>
        <Link to="https://apps.apple.com/in/app/memyfolks-family-tree-app/id6475598695" target="_blank">
        <AiOutlineApple className='nav-icons' />
        </Link>
        <button onClick={()=>window.location.href = "/app"}>LOGIN OR SIGNUP</button>
      </div>
    </nav>
  );
};

export default Nav;
